






































































import Vue from 'vue'
import { Component, Config } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import { ExportExcelResourceType, ExportExcelStatus } from '@/modules/common/table-export/models/export-resource.model'
import { ExportRequestUseCase } from '@/modules/common/table-export/use-cases/export-request.use-case'
import { ExportCheckStatusUseCase } from '@/modules/common/table-export/use-cases/export-check-status.use-case'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'

@Component({
  components: { BaseButton }
})
export default class TableExportButton extends Vue {
  constructor(
    private readonly exportRequestUseCase: ExportRequestUseCase,
    private readonly exportCheckStatusUseCase: ExportCheckStatusUseCase,
    private readonly userBootUseCase: UserBootUseCase
  ) {
    super()
  }

  @Prop() exportRoute!: string
  @Prop({ default: true }) expand!: boolean
  @Prop({ required: false }) total!: number
  currentPage: string
  requestResult: ExportExcelResourceType | { url: string }
  loading: boolean = false
  interval: any
  userType = Config.get('userType')
  totalData: number = 0
  overLimitationDialog: boolean = false

  get showCondition() {
    if (this.userType === 'admin') {
      return this.userBootUseCase.can('export-excel')
    }
    return true
  }

  metaTotal() {
    if (this.total)
      return this.total
    else {
      try {
        let parentProps = this.$parent.$parent.$options.propsData
        let key = Object.keys(parentProps)[0]
        return this.$parent.$parent.$options.propsData[key].meta.total
      } catch {
        return 0
      }
    }
  }

  exportUrl(): string {
    this.currentPage = window.location.href
    let pageParamRegex = /^page=\d*$/
    //---
    let params = this.currentPage.split('?')[1]
    let paramsArray = params?.split('&') || []
    params = paramsArray.filter(e => !pageParamRegex.test(e)).join('&')
    return (params) ? (this.exportRoute + '?' + params) : (this.exportRoute)
  }

  exportRequest() {
    this.totalData = this.metaTotal() || 0
    this.$emit('clicked')
    if (this.totalData >= 10000)
      this.overLimitationDialog = true
    else this.callForExport()
  }

  callForExport() {
    this.loading = true
    this.exportRequestUseCase.execute(this.exportUrl())
      .then(() => {
        this.requestResult = this.exportRequestUseCase.data
        if (this.requestResult['url']) {
          this.loading = false
          window.open(this.requestResult['url'], '_self')
        } else this.checkExportStatus(this.requestResult['data'].id)
      })
      .catch((err) => {
        this.loading = false
      })
  }

  checkExportStatus(exportExcel) {
    this.interval = setInterval(() => {
      this.exportCheckStatusUseCase.execute(exportExcel)
        .then(() => {
          if (this.exportCheckStatusUseCase.data.status === ExportExcelStatus.PENDING)
            return
          else {
            window.open(this.exportCheckStatusUseCase.data.url, '_self')
            this.loading = false
            clearInterval(this.interval)
          }
        })
        .catch((err) => {
          this.loading = false
        })
    }, 1000)
  }

}

